import { ProductType } from '@sales-domain/product-config';

export enum SegmentEvents {
  Identify = 'Identify Segment User',
  OrderStarted = 'Order Started',
  OrderUpdated = 'Order Updated',
  OrderCompleted = 'Order Completed',
  PaymentInfoEntered = 'Payment Info Entered',
  CheckoutStarted = 'Checkout Started',
  CheckoutStepViewed = 'Checkout Step Viewed',
  CheckoutStepCompleted = 'Checkout Step Completed',
  ProductAdded = 'Product Added',
  ProductRemoved = 'Product Removed',
  ProductViewed = 'Product Viewed',
  CartViewed = 'Cart Viewed',
}

export function isSegmentEvent(event: string): event is SegmentEvents {
  return Object.values<string>(SegmentEvents).includes(event);
}

export type SegmentProduct = {
  id?: string;
  productId?: string;
  sku?: string;
  category?: ProductType;
  name?: string;
  brand: string;
  price?: number;
  quantity: number;
  coupon?: string;
};

export type SegmentAffiliation =
  | 'DigitalEnrollment'
  | 'FieldApp'
  | 'SalesTool'
  | 'Messaging'
  | 'Claims'
  | 'PartnerEnrollment';

export type TrackSegmentEcommerceEventPayload = {
  eventName: SegmentEvents;
  userId: string; // email address of the user
  properties: {
    correlationId: string;
    affiliation:
      | 'DigitalEnrollment'
      | 'FieldApp'
      | 'Glow'
      | 'Messaging'
      | 'Claims';
    orderId: string; // use the product offer id
    isEnrolled: number;
    total: number;
    products: SegmentProduct[];
    currency: 'USD' | 'GBP' | 'EUR';
    pageUrl?: string;
    previousPageUrl?: string;
    productSku?: string;
    tax?: number;
    discount?: number;
    coupon?: string;
    step?: number;
    paymentMethod?: 'Credit Card' | 'PayPal';
  };
  context?: {
    campaign?: {
      name?: string;
      source?: string;
      medium?: string;
    };
  };
  integrations?: {
    'Google Analytics'?: string;
  };
};

export type IdentifySegmentUserPayload = {
  userId: string;
  traits: {
    correlationId: string;
    isEnrolled: number;
    firstName?: string;
    lastName?: string;
    mdn?: string;
    destination?: string;
    productSku?: string;
  };
};
export type IdentifySegmentUserInput = {
  customer: {
    email: string;
    firstName: string;
    lastName: string;
    mdn: string;
  };
  customerSession: {
    id: string;
  };
};
export type TrackSegmentEcommerceEventInput = {
  affiliation?:
    | 'DigitalEnrollment'
    | 'FieldApp'
    | 'Glow'
    | 'Messaging'
    | 'Claims';
  customerSessionId: string;
  email: string;
  eventName: SegmentEvents;
  productOfferId?: string;
  step: number;
  tax?: number;
  isEnrolled?: number;
  paymentMethod?: 'Credit Card' | 'PayPal';
};
